import React from 'react'
import '../assets/css/commonModal.scss'

const Confirmation = ({
    title,
    handleSubmit,
    handleClose,
    activeCanvasId,
    openModal
}) => {
    if (openModal) {
        return (
            <div className='confirmation-modal'>
                <div className='confirmation-modal-content'>
                    <div className='confirmation-modal-header'>
                        <h4>{title}</h4>
                        <button
                            type='button'
                            className='close'
                            onClick={handleClose}
                        >
                            <span>×</span>
                        </button>
                    </div>
                    <div className='confirm-buttons'>
                        <button
                            type='submit'
                            className='white'
                            onClick={handleClose}
                        >
                            Cancel
                        </button>
                        <button
                            type='submit'
                            className='black'
                            onClick={() => handleSubmit(activeCanvasId)}
                        >
                            Confirm
                        </button>
                    </div>
                </div>
            </div>
        )
    } else {
        return ''
    }
}

export default Confirmation
